import React from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../components/Utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {userLogout} from "./UsersSlice";

const RegisterBlock = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const dispatch = useDispatch();

  const logoutRequest = () => {
    dispatch(userLogout(false));
  }

  return (
    <ul className="inline-ul">
      <li className="nav-item ">
        {
          !isAuthenticated ?
            <a className="nav-link strong" href={ "/" + locale + t("url_create_account")} role="button">{t('register')}</a>
            :
            null
        }
      </li>
      <li className="nav-item ">
        {
          !isAuthenticated ?
            <a className="nav-link strong" href={ "/" + locale + t('url_login')} role="button">{t('login')}</a>
            :
            <button className="nav-link strong" onClick={() => logoutRequest() } role="button">{t('logout')}</button>
        }
      </li>
    </ul>
  )
}
export default RegisterBlock;
